import React, { useEffect } from "react";
import environment from "../../environment";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import logo from "../../assets/images/logo.webp";
import HomeBG from "../../assets/images/backGrounds/homePageBG.webp";
const Styles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url(${HomeBG});
  /* background-size: 100% 100%; */
  background-size: cover;
  background-repeat: no-repeat;
  border-bottom-left-radius: 350px;
  border-bottom-right-radius: 350px;
  img {
    width: 200px;
    margin-bottom: 1rem;
  }
  p {
    font-size: 1.2rem;
    font-weight: 500;
    color: var(--dark-purple);
  }
  @media (max-width: 550px) {
    height: 80vh;
    p {
      font-size: 1.1rem;
    }
  }
`;
const EndSession = () => {
  const { t } = useTranslation();
  const { courseId } = useParams();
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem(environment.TOKEN_KEY);

  // useEffect(() => {
  //   if (isLoggedIn) {
  //     navigate(`/live-course/${courseId}`, { replace: true });
  //   } else {
  //     window.parent.location.href = `https://cpanel.darrebni.net/Admin/CourseSession`;
  //   }
  // }, []);
  return (
    <Styles>
      <img src={logo} alt="Darrebni" />
      <p className="text-center">{t("session ended")}</p>
    </Styles>
  );
};

export default EndSession;
